import dayjs from "dayjs";
import { CancellationReport } from "../../hooks/react-query/linehaul/useCancellationReport";

export const cancellationReportMock = {
  default: [
    {
      scheduleId: 1234567890,
      tripNumber: 0,
      tonu: 0,
      originSicCode: "MDW-CXIT",
      vendorName: "DEL001 - D E L TRANSPORT INC",
      vendorId: "DEL001",
      destinationSicCode: "ONT",
      bookingNumber: "EDUARDO/GUILLERMO",
      serviceType: "Fleet 1",
      pickupTimestamp: dayjs("2025-06-02T23:59:00"),
      loadingTimestamp: dayjs("2025-06-02T00:00:00"),
      statusName: "DYLT CANCELLED",
      notes: null,
      cancelledBy: "User 1",
      cancelledDateUtc: dayjs("2025-05-29T22:51:35.794925Z"),
    },
    {
      scheduleId: 234567890,
      tripNumber: 10007254,
      tonu: 20,
      originSicCode: "ATM",
      vendorName: "PARENTS TRANSPORTATION LLC",
      vendorId: "PAR002",
      destinationSicCode: "DAL",
      bookingNumber: "KOYOM KOYOM/OUSMAN DIBBA",
      serviceType: "Fleet 2",
      pickupTimestamp: dayjs("2025-06-04T23:59:00"),
      loadingTimestamp: dayjs("2025-06-04T00:00:00"),
      statusName: "DYLT CANCELLED",
      notes: ["Daylight Cancelled - test"],
      cancelledBy: "User 2",
      cancelledDateUtc: dayjs("2025-06-04T22:14:41.613884Z"),
    },
    {
      scheduleId: 345678901,
      tripNumber: 3122530,
      tonu: 0,
      originSicCode: "DAL",
      vendorName: "SAM HARDY LLC",
      vendorId: "M265",
      destinationSicCode: "LRD",
      bookingNumber: "SAM/DONG",
      serviceType: "Shuttle 3",
      pickupTimestamp: dayjs("2025-06-01T23:00:00"),
      loadingTimestamp: dayjs("2025-06-01T00:00:00"),
      statusName: "DYLT CANCELLED",
      notes: ["Test_Note_1", "Test_Note_2", "Test_Note_3", "Test_Note_4"],
      cancelledBy: "User 3",
      cancelledDateUtc: dayjs("2025-05-29T22:51:49.162584Z"),
    },
  ],
} as const satisfies Record<string, CancellationReport[]>;
